import { useTranslation } from "@bounce/i18n"

import type { Interpolations } from "./useInterpolations"
import type { PoiData } from "@/libs/bounce/pois"
import { interpolateText } from "@/libs/prismic/helpers"

export type UseSEOOptions = {
  poi: Pick<PoiData, "splitTestData" | "metaTitle" | "metaDescription" | "mainStore">
  interpolations: Interpolations
}

const useMetaTitle = ({ poi, interpolations }: UseSEOOptions) => {
  const { t } = useTranslation("marketing-ls-poi")

  if (poi.splitTestData.metaTitle) {
    return interpolateText(poi.splitTestData.metaTitle, interpolations)
  }

  return t("page.place.metaTitleV11", "Luggage Storage Near {PLACE_NAME} - Trusted by Travelers", interpolations)
}

const useMetaDescription = ({ interpolations }: Pick<UseSEOOptions, "interpolations">) => {
  const { t } = useTranslation("marketing-ls-poi")

  return t(
    "page.place.metaDescriptionV4",
    "Best-rated {{PLACE_NAME}} luggage storage for only {{PRICE}}/ day. Booking includes {{INSURANCE_AMOUNT}} protection and free cancellation.",
    interpolations,
  )
}

export const useSEO = ({ poi, interpolations }: UseSEOOptions) => {
  const metaTitle = useMetaTitle({ poi, interpolations })
  const metaDescription = useMetaDescription({ interpolations })

  return {
    metaTitle,
    metaDescription,
  }
}
